export default __webpack_public_path__ + "static/media/031-hill.22a326c4.svg";